import {ReadApiCall} from '../../reader/message/ReadApiCall';

export class ApiToTableConfiguration extends ReadApiCall {
exitStatusOnNoObtainedData: boolean | null;
fieldName: string;
responseRootFieldName: string;
tableName: string;
truncateTable: boolean | null;
}

